import React, { useEffect, useState } from 'react';
import API from '../api/axios';
import Header from '../components/Header';
import { Search, Wallet, Phone, MapPin } from 'lucide-react';

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    API.get('/auth/users/').then(r => setCustomers(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = customers.filter(c =>
    !search ||
    `${c.first_name} ${c.last_name}`.toLowerCase().includes(search.toLowerCase()) ||
    c.email?.toLowerCase().includes(search.toLowerCase()) ||
    c.username?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="flex-1 overflow-auto">
      <Header title="Customers" subtitle={`${customers.length} registered users`} />
      <div className="p-6 space-y-4">
        <div className="relative">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input type="text" placeholder="Search customers by name, email or username..." className="input pl-9 max-w-sm"
            value={search} onChange={e => setSearch(e.target.value)} />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {loading ? [...Array(8)].map((_, i) => (
            <div key={i} className="card animate-pulse">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-gray-200 rounded-2xl" />
                <div className="flex-1"><div className="h-4 bg-gray-200 rounded mb-1.5" /><div className="h-3 bg-gray-100 rounded w-2/3" /></div>
              </div>
              <div className="space-y-2"><div className="h-3 bg-gray-100 rounded" /><div className="h-3 bg-gray-100 rounded w-3/4" /></div>
            </div>
          )) : filtered.map(c => (
            <div key={c.id} className="card hover:shadow-md transition-all">
              <div className="flex items-center gap-3 mb-4">
                <img src={c.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(c.full_name || c.username)}&background=${c.role === 'admin' ? 'f3700e' : 'dbeafe'}&color=${c.role === 'admin' ? 'fff' : '3b82f6'}&size=100`}
                  alt={c.full_name} className="w-12 h-12 rounded-2xl object-cover flex-shrink-0" />
                <div className="min-w-0">
                  <p className="font-bold text-gray-900 text-sm truncate">{c.first_name} {c.last_name}</p>
                  <p className="text-xs text-gray-400">@{c.username}</p>
                </div>
                <span className={`badge ml-auto flex-shrink-0 ${c.role === 'admin' ? 'bg-orange-100 text-orange-600' : 'bg-blue-100 text-blue-600'}`}>
                  {c.role}
                </span>
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <Phone size={12} className="text-gray-400 flex-shrink-0" />
                  <span className="truncate">{c.phone || 'No phone'}</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <MapPin size={12} className="text-gray-400 flex-shrink-0" />
                  <span>{c.city || 'No city'}</span>
                </div>
                <div className="flex items-center gap-2 text-xs">
                  <Wallet size={12} className="text-green-500 flex-shrink-0" />
                  <span className="font-bold text-green-600">₹{parseFloat(c.wallet_balance || 0).toFixed(2)}</span>
                  <span className="text-gray-400">wallet</span>
                </div>
              </div>
              <div className="mt-3 pt-3 border-t border-gray-100">
                <p className="text-xs text-gray-400">
                  Joined {new Date(c.created_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                </p>
              </div>
            </div>
          ))}
        </div>
        {!loading && filtered.length === 0 && (
          <div className="text-center py-12 text-gray-400">
            <div className="text-4xl mb-3">👤</div>
            <p>No customers found</p>
          </div>
        )}
      </div>
    </div>
  );
}
